<script>
export default {
  name: 'CpBaseSvgIcon',
  props: {
    viewBox: { type: String, default: '0 0 24 24'},
    iconName: { type: String, default: ''},
    width: { type: [Number, String], default: 18 },
    height: {type: [Number, String], default: 18 },
    iconColor: {type: String, default: 'currentColor'},
    strokeColor: {type: String, default: 'none'}
  }
}
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="iconName"
  >
    <title :id="iconName" lang="en">{{iconName}}</title>
    <g :fill="iconColor" :stroke="strokeColor">
      <slot />
    </g>
  </svg>
</template>
<style>
 .base-svg-icon {
   /* Add some default CSS declaration blocks */
 }
 </style>
